module.exports = __webpack_public_path__ + "img/duo-icons.305f6f5.svg";